import { useRoutes } from 'react-router-dom'
import { ThemeProvider } from '@mui/material'
import {
  cacheExchange,
  createClient,
  debugExchange,
  fetchExchange,
  subscriptionExchange,
  Provider as UrqlProvider,
} from 'urql'
import { theme, I18nProvider, useLocale } from '@innovatrics/checkin-components'
import { createClient as createWSClient } from 'graphql-ws'

import './global.css'
import routes from './routes'
import { messages } from './locale'
import { LastCustomerContextProvider } from './components/LastCustomerContext'

const subscriptionClient = createWSClient({
  url: (import.meta.env.VITE_HASURA_GRAPHQL_ENDPOINT as string).replace(
    'https',
    'wss'
  ),
})

const client = createClient({
  url: import.meta.env.VITE_HASURA_GRAPHQL_ENDPOINT as string,
  exchanges: [
    debugExchange,
    cacheExchange,
    fetchExchange,
    subscriptionExchange({
      forwardSubscription: (operation) => {
        return {
          subscribe: (sink) => {
            const dispose = subscriptionClient.subscribe(operation, sink)
            return {
              unsubscribe: dispose,
            }
          },
        }
      },
    }),
  ],
})

const App = () => {
  const routing = useRoutes(routes)
  const locale = useLocale()
  return (
    <UrqlProvider value={client}>
      <LastCustomerContextProvider>
        <I18nProvider locale={locale} messages={messages(locale)}>
          <ThemeProvider theme={theme}>{routing}</ThemeProvider>
        </I18nProvider>
      </LastCustomerContextProvider>
    </UrqlProvider>
  )
}

export default App
